/**
 * PackRelatedStrip.module.scss — Toile. Retokened from narcis's own PackRelatedStrip.module.scss
 * onto `--tl-*` (styles/index.scss); no other structural change.
 */

.rel {
    max-width: 1200px;
    width: 100%;
    margin: 0 auto;
    padding: 8px 26px 40px;
    box-sizing: border-box;

    @media (max-width: 900px) {
        padding: 8px 26px 32px;
    }

    @media (max-width: 600px) {
        padding: 4px 18px 28px;
    }
}

.relHead {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    gap: 16px;
    margin: 0 0 16px;
}

.relTitle {
    font-weight: 500;
    font-size: 22px;
    letter-spacing: -0.01em;
    color: var(--tl-text);
    margin: 0;
}

.relLink {
    font-family: 'JetBrains Mono', monospace;
    font-size: 11px;
    letter-spacing: 0.06em;
    color: var(--tl-accent);
    white-space: nowrap;

    &:hover { color: var(--tl-text); }
    &:focus-visible { outline: 2px solid var(--tl-accent); outline-offset: 2px; border-radius: 4px; }
}

.relGrid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 14px;

    @media (max-width: 1023px) {
        grid-template-columns: repeat(2, 1fr);
    }

    @media (max-width: 639px) {
        grid-template-columns: none;
        grid-auto-flow: column;
        grid-auto-columns: 66vw;
        overflow-x: auto;
        scroll-snap-type: x mandatory;
        padding-bottom: 4px;
        -webkit-overflow-scrolling: touch;
    }
}

.relCard {
    display: flex;
    flex-direction: column;
    border: 1px solid var(--tl-border);
    border-radius: 8px;
    overflow: hidden;
    background: var(--tl-surface);
    text-decoration: none;
    color: inherit;
    transition: border-color 150ms ease;

    &:hover { border-color: var(--tl-border-strong); }
    &:focus-visible { outline: 2px solid var(--tl-accent); outline-offset: -2px; }

    @media (max-width: 639px) {
        scroll-snap-align: start;
    }
}

.relCardPh {
    display: block;
    aspect-ratio: 1 / 1;
    background: var(--tl-stage);
}

.relCardImg {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
}

.relCardTitle {
    display: block;
    padding: 10px 12px 12px;
    font-size: 13px;
    font-weight: 600;
    color: var(--tl-text);
}

.relCardMeta {
    display: block;
    font-style: normal;
    font-family: 'JetBrains Mono', monospace;
    font-size: 10px;
    font-weight: 400;
    letter-spacing: 0.04em;
    color: var(--tl-dim);
    margin-top: 3px;
}
